export class DeserializeObjectContext {
    deserializeOptions = {};
    parentContext = null;
    isRoot;
    ser;
    target = null;
    modelSchema;
    currentArgs;
    rootContext;
    rootArgs;
    constructor(context) {
        Object.assign(this, context);
        this.isRoot = !context.parentContext;
        if (!context.parentContext) {
            this.rootContext = this;
            this.rootArgs = context.currentArgs;
        }
        else {
            this.rootContext = context.parentContext.rootContext;
            this.rootArgs = context.parentContext.rootArgs;
        }
    }
}
